import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  collectionListSuccessful,
} from "./collectionSlice";
import { getParamsList } from "../../../helpers/Helper";

function* fetchCollectionList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/collections/admin/", params);
    yield put(collectionListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* CollectionSaga() {
  yield all([
    fork(function* () {
      yield takeEvery("collection/getCollectionList", fetchCollectionList);
    }),
  ]);
}

export default CollectionSaga;
